import { isJaneUser } from '@iheartjane/data-access';
import { useToast } from '@iheartjane/reefer';
import { useCallback } from 'react';

import { FavoriteSavedToastLabel } from '@jane/bloom/components/toast/favoriteSavedToastLabel';
import {
  setPendingFavorite,
  usePendingFavorite,
} from '@jane/bloom/hooks/usePendingFavorite';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { useAuthModal } from '@jane/bloom/providers/authModalProvider';

export const useFavoriteToggle = (productId: number) => {
  const { whoami } = useRootLoaderData();
  const isSignedIn = isJaneUser(whoami.user);
  const { openAuthModal } = useAuthModal();
  const toast = useToast();
  // TODO: Fall back to the SDK's is_favorite instead of false, and roll back the override if the toggle action fails
  const pendingFavorite = usePendingFavorite(productId);
  const isFavorite = isSignedIn && (pendingFavorite ?? false);

  const toggleFavorite = useCallback(() => {
    if (!isSignedIn) {
      openAuthModal({
        onSuccess: () => setPendingFavorite(productId, true),
      });
      return;
    }

    if (!isFavorite) {
      toast.add({ label: <FavoriteSavedToastLabel /> });
    }
    setPendingFavorite(productId, !isFavorite);
  }, [isFavorite, isSignedIn, openAuthModal, productId, toast]);

  return { isFavorite, toggleFavorite };
};
